<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">积分明细</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="4" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="flex-box mb25">
                    <div class="col90 mr80">类型</div>
                    <div class="cursor type" :class="navIndex == 0 ? 'active' : ''" @click="changeType(0)">全部</div>
                    <div class="cursor type" :class="navIndex == 1 ? 'active' : ''" @click="changeType(1)">收入</div>
                    <div class="cursor type" :class="navIndex == 2 ? 'active' : ''" @click="changeType(2)">支出</div>
                </div>
                <div class="flex-box mb25">
                    <div class="col90 mr45">筛选时间</div>
                    <div class="select_box relative">
                        <div class="flex-box select  cursor">
                            <div class="flex-grow-1" :class="startTime == '' ? 'col90' : 'col04'">{{ startTime ==
                                '' ? '请选择' : startTime }}</div>
                        </div>
                        <input class="input_time" v-model="startTime" type="date" @click="openDatePicker" />
                    </div>
                    <div class="col90 mlr25">至</div>
                    <div class="select_box relative">
                        <div class="flex-box select  cursor">
                            <div class="flex-grow-1" :class="endTime == '' ? 'col90' : 'col04'">{{ endTime == '' ? '请选择' :
                                endTime
                            }}</div>
                        </div>
                        <input class="input_time" v-model="endTime" type="date" @click="openDatePicker" />
                    </div>
                    <div class="sort colf fs14 cursor" @click="scoreSearch">搜索</div>
                    <div class="sort active fs14 cursor" @click="setSearch">重置</div>
                    
                </div>
                <div class="fs18 col3d fwb"><span class="pr30">支出：{{ total_zhic }}积分</span><span>收入：{{ total_shouru
                }}积分</span>
                </div>
                <div class="list_box fs14 mt35" v-if="list.length > 0">
                    <div class="title_box flex-box col04">
                        <div class="box2 tc">时间</div>
                        <div class="box3 tc">订单号</div>
                        <div class="box4 tc">说明</div>
                        <div class="flex-grow-1 tc">积分</div>
                    </div>
                    <div class="address_box flex-box col90" v-for="(item, index) in list" :key="index">
                        <div class="box2 tc">{{ item.createtime_text }}</div>
                        <div class="box3 tc col04">{{ item.order.order_sn }}</div>
                        <div class="box4 tc ">{{ item.memo }}</div>
                        <div class="flex-grow-1 tc coleb" v-if="item.commission > 0">+ {{ item.commission }}</div>
                        <div class="flex-grow-1 tc col00" v-else>{{ item.commission }}</div>
                    </div>
                </div>
                <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                </pagination>
            </div>
        </div>

        <loading-component></loading-component>

    </div>
</template>

<script>
import PersonalNav from "../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "积分明细-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            navIndex: 0,
            userId: 0,
            startTime: '',
            endTime: '',
            page: 1,
            sumCount: 0,
            perCount: 10,
            total_shouru: 0,
            total_zhic: 0,
            list: [],
        };
    },
    created() {
        this.userId = this.$route.query.id
        this.getList();
    },
    methods: {
        changeType(index) {
            this.navIndex = index;
            this.page = 1;
            this.getList();
        },
        setSearch(){
            this.startTime = '';
            this.endTime = '';
            this.page = 1;
            this.getList();
        },
        scoreSearch(){
            //console.log(this.startTime,'---',this.endTime)
            this.page = 1;
            this.getList();
        },
        // 获取收益明细
        getList() {
            this.$api.scoreLists({
                page: this.page,
                type: this.navIndex,
                start_date: this.startTime,
                end_date: this.endTime,
                user_id: this.userId
            }, true).then(res => {
                this.list = res.data.data;
                this.sumCount = res.data.total;
                this.perCount = res.data.per_page;
                this.total_shouru = res.data.total_shouru;
                this.total_zhic = res.data.total_zhic;
            })
        },
        // 选择起始时间
        openDatePicker(event) {
            // 触发日期选择器
            event.target.showPicker(); // 仅在支持的浏览器中有效
        },
        //
        //分页
        pageTurn(e) {
            this.page = e + 1;
            this.getList();
        },
    },
};
</script>

<style lang="less" scoped>
.mr92 {
    margin-right: 92px;
}

.part_r {
    padding: 42px 44px 100px;
    background: #fff;

    .sort {
        width: 108px;
        background: #1275FF;
        border-radius: 6px;
        font-weight: 500;
        line-height: 38px;
        text-align: center;
        margin-left: 30px;
        border: 1px solid #1275FF;
        &.active{
            background: #fff;
            color: #1275FF;
        }
    }

    .type {
        margin-right: 92px;

        &:hover,
        &.active {
            color: #3D7EFE;
        }
    }

    .select_box {
        width: 170px;
        height: 40;
        border-radius: 8px;
        border: 1px solid rgba(98, 134, 171, 0.2);

    }

    .select_box .select {
        height: 38px;
        position: relative;
        background: #fff;
        padding: 0 24px 0 18px;
        border-radius: 8px;
    }

    .select_box .select::after {
        content: "";
        display: block;
        background: url('/src/assets/static/icon/c_arrowd.png') no-repeat center;
        background-size: 100%;
        width: 16px;
        height: 16px;
    }

    .input_time {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 48px;
        z-index: 2;
        cursor: pointer;
        opacity: 0;
    }

    .title_box {
        padding-left: 44px;
        height: 50px;
        background: #fafcff;
    }

    .address_box {
        padding-left: 44px;
        height: 50px;
        border-bottom: 1px solid #c0cfdd;
    }


    .box2 {
        width: 306px;
    }

    .box3 {
        width: 350px;
    }

    .box4 {
        width: 200px;
    }
}
</style>
